var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoleSelect(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_726_14496)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_726_14496)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.66667 8.16268C9.69171 8.16268 11.3333 6.52106 11.3333 4.49601C11.3333 2.47097 9.69171 0.829346 7.66667 0.829346C5.64162 0.829346 4 2.47097 4 4.49601C4 6.52106 5.64162 8.16268 7.66667 8.16268Z",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6667 9.29199C10.356 9.29199 9.29199 10.356 9.29199 11.6667C9.29199 12.9773 10.356 14.042 11.6667 14.042C12.9773 14.042 14.042 12.9773 14.042 11.6667C14.042 10.356 12.9773 9.29199 11.6667 9.29199ZM11.6667 10.292C12.4253 10.292 13.042 10.908 13.042 11.6667C13.042 12.4253 12.4253 13.042 11.6667 13.042C10.908 13.042 10.2913 12.4253 10.2913 11.6667C10.2913 10.908 10.908 10.292 11.6667 10.292Z",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.166 9.79142V8.66675C12.166 8.39075 11.942 8.16675 11.666 8.16675C11.39 8.16675 11.166 8.39075 11.166 8.66675V9.79208C11.166 10.0674 11.39 10.2921 11.666 10.2921C11.942 10.2914 12.166 10.0674 12.166 9.79142Z",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3455 10.6946L14.1409 9.89858C14.3362 9.70391 14.3362 9.38658 14.1409 9.19191C13.9462 8.99658 13.6289 8.99658 13.4342 9.19191L12.6382 9.98724C12.4435 10.1826 12.4435 10.4992 12.6382 10.6946C12.8335 10.8892 13.1502 10.8892 13.3455 10.6946Z",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5413 12.1667H14.6667C14.9427 12.1667 15.1667 11.9427 15.1667 11.6667C15.1667 11.3907 14.9427 11.1667 14.6667 11.1667H13.5413C13.266 11.1667 13.042 11.3907 13.042 11.6667C13.0413 11.9427 13.266 12.1667 13.5413 12.1667Z",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6382 13.346L13.4342 14.1413C13.6289 14.3367 13.9462 14.3367 14.1409 14.1413C14.3362 13.9467 14.3362 13.6293 14.1409 13.4347L13.3455 12.6387C13.1502 12.444 12.8335 12.444 12.6382 12.6387C12.4435 12.834 12.4435 13.1507 12.6382 13.346Z",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.166 13.5413V14.6666C11.166 14.9426 11.39 15.1666 11.666 15.1666C11.942 15.1666 12.166 14.9426 12.166 14.6666V13.5413C12.166 13.2659 11.942 13.0419 11.666 13.0413C11.39 13.0413 11.166 13.2659 11.166 13.5413Z",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.98676 12.6387L9.19142 13.4347C8.99609 13.6293 8.99609 13.9467 9.19142 14.1413C9.38609 14.3367 9.70342 14.3367 9.89809 14.1413L10.6941 13.346C10.8888 13.1507 10.8888 12.834 10.6941 12.6387C10.4988 12.444 10.1821 12.444 9.98676 12.6387Z",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.79068 11.1667H8.66602C8.39002 11.1667 8.16602 11.3907 8.16602 11.6667C8.16602 11.9427 8.39002 12.1667 8.66602 12.1667H9.79068C10.0667 12.1667 10.2913 11.9427 10.2907 11.6667C10.2907 11.3907 10.0667 11.1667 9.79068 11.1667Z",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6941 9.98724L9.89809 9.19191C9.70342 8.99658 9.38609 8.99658 9.19142 9.19191C8.99609 9.38658 8.99609 9.70391 9.19142 9.89858L9.98676 10.6946C10.1821 10.8892 10.4988 10.8892 10.6941 10.6946C10.8888 10.4992 10.8888 10.1826 10.6941 9.98724Z",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.62367 14.504C8.26767 14.0466 8.29967 13.3833 8.72034 12.9633L8.84967 12.8333H8.66634C8.02234 12.8333 7.49967 12.3106 7.49967 11.6666C7.49967 11.0226 8.02234 10.5 8.66634 10.5H8.84967L8.72034 10.37C8.28301 9.93331 8.26568 9.23397 8.66834 8.77597C8.34167 8.75064 8.00701 8.7373 7.66634 8.7373C5.45167 8.7373 3.49101 9.2913 2.27367 10.1213C1.34501 10.7546 0.833008 11.5593 0.833008 12.404V13.3706C0.833008 13.6713 0.952341 13.96 1.16501 14.172C1.37767 14.3846 1.66567 14.504 1.96634 14.504H8.62367Z",
    fill: "currentcolor"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_726_14496"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_726_14496"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoleSelect);
export default __webpack_public_path__ + "static/media/role-select.09f33b4f860685b644230abd9ef82793.svg";
export { ForwardRef as ReactComponent };